/* Pattern-based milestone detection for the mock adapter (Phase 1) — generated
 * by sales-academy-factory with an EMPTY rule set. The live classifier produces
 * the real milestone events; add regex rules here by hand to enrich mock mode. */

import type { PersonaId } from '@/lib/codebaby';
import { defaultMomentType } from './milestones';
import type { MilestoneEvent, MilestoneTag } from './types';

interface DetectorInput {
  personaId: PersonaId;
  producerText: string;
  personaText: string;
  turnId: string;
  alreadyHit: MilestoneTag[];
}

interface Rule {
  tag: MilestoneTag;
  match: (input: DetectorInput) => boolean;
  fireOnce?: boolean;
}

const RULES_BY_PERSONA: Partial<Record<PersonaId, Rule[]>> = {};

/** Run the detector for one turn pair, returning the milestones that fired. */
export function detectMilestones(input: DetectorInput): MilestoneEvent[] {
  const rules = RULES_BY_PERSONA[input.personaId];
  if (!rules) return [];

  const fired: MilestoneEvent[] = [];
  const seen = new Set(input.alreadyHit);

  for (const rule of rules) {
    if ((rule.fireOnce ?? true) && seen.has(rule.tag)) continue;
    if (!rule.match(input)) continue;
    fired.push({
      tag: rule.tag,
      turnId: input.turnId,
      producerText: input.producerText,
      isKeyMoment: true,
      momentType: defaultMomentType(rule.tag),
    });
    seen.add(rule.tag);
  }

  return fired;
}
